import React from 'react';
import * as LucideIcons from 'lucide-react';
import { HelpCircle } from 'lucide-react';
import * as BoxIcons from 'react-icons/bi';
import * as SimpleIcons from 'react-icons/si';

// Aliases for Lucide icons (values are Lucide component names)
const LUCIDE_ALIASES = {
    automation: 'Workflow',
};

// Aliases for Boxicons (values are React-Icons component names from `react-icons/bi`)
const BOXICON_ALIASES = {
    automation: 'BiCogs',
};

// Aliases for Simple Icons (values are component names from `react-icons/si`)
const SIMPLE_ICON_ALIASES = {
    ibm: 'SiIbm',
    figma: 'SiFigma',
    workato: 'SiWorkato',
};

function toPascalCaseIconKey(rawName) {
    if (!rawName || typeof rawName !== 'string') return '';
    return rawName
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim()
        .split(' ')
        .map(part => part.charAt(0).toUpperCase() + part.slice(1))
        .join('');
}

function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    const normalizedName = typeof name === 'string' ? name.trim() : '';
    let IconComponent = LucideIcons[normalizedName];

    // Try Lucide alias mapping
    if (!IconComponent && normalizedName) {
        const aliasLucide = LUCIDE_ALIASES[normalizedName.toLowerCase()];
        if (aliasLucide) {
            IconComponent = LucideIcons[aliasLucide];
        }
    }

    // Fallback to Boxicons if Lucide is not found
    if (!IconComponent && normalizedName) {
        // 1) Try Boxicon alias mapping first
        const aliasBox = BOXICON_ALIASES[normalizedName.toLowerCase()];
        if (aliasBox && BoxIcons[aliasBox]) {
            IconComponent = BoxIcons[aliasBox];
        } else {
            // 2) Try to directly resolve Bi + PascalCase(name)
            const biKey = `Bi${toPascalCaseIconKey(normalizedName)}`;
            if (BoxIcons[biKey]) {
                IconComponent = BoxIcons[biKey];
            }
        }
    }

    // Fallback to Simple Icons for brands
    if (!IconComponent && normalizedName) {
        // 1) Aliases
        const aliasSi = SIMPLE_ICON_ALIASES[normalizedName.toLowerCase()];
        if (aliasSi && SimpleIcons[aliasSi]) {
            IconComponent = SimpleIcons[aliasSi];
        } else {
            // 2) Direct Si + PascalCase(name)
            const siKey = `Si${toPascalCaseIconKey(normalizedName)}`;
            if (SimpleIcons[siKey]) {
                IconComponent = SimpleIcons[siKey];
            }
        }
    }

    if (!IconComponent) {
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    return <IconComponent
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
    />;
}
export default Icon;